<template>
  <div>
    <div class="container NewsContent">
      <div class="NewsContent-l">
        <h3>{{this.news.infoTitle}}</h3>
        <h5>{{this.news.type}} {{this.news.infoDate}}</h5>
        <div v-for="(item,index) in this.news.jsonContent" :key="index">
          <p v-if="item.str" v-html="item.str"></p>
          <img v-if="item.img" :src="item.img" alt />
        </div>
        <div class="btns">
          <div class="prevbtn">
            <router-link tag="a" :to="{name:'NewsContent',query: {id:prevbtn.id}}">
                <span>上一篇</span> {{prevbtn.infoTitle}}
            </router-link>
            <!-- <el-link type="primary" @click="getNewsContent(prevbtn.id)"><span>上一篇</span> {{prevbtn.infoTitle}}</el-link> -->
          </div>
          <div class="nextbtn">
           <router-link tag="a" :to="{name:'NewsContent',query: {id:nextbtn.id}}">
                <span>下一篇</span> {{nextbtn.infoTitle}}
            </router-link>
             <!-- <el-link type="primary" @click="getNewsContent(nextbtn.id)"><span>下一篇</span> {{nextbtn.infoTitle}}</el-link> -->
          </div>
        </div>
      </div>
      <div class="NewsContent-r">
        <p class="NewsContent-r-title">热点标题</p>
        <div v-for="(item,index) in this.hotContent" :key="index" >
          <div class="NewsContent-part" v-if="item.id != id">
            <p class="details-title" v-text="item.infoTitle"></p>
            <router-link tag="a" :to="{name:'NewsContent',query: {id:item.id}}">
                  详情 >>
            </router-link>
          </div>       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {replaceStr} from '@/utils/validate';
export default {
  name: "NewsContent",
  data() {
    return {
      id: 0,
      news: {},
      prevbtn:{},
      nextbtn:{},
      hotContent:[]
    };
  },
  watch:{
    $route (newRoute) {
      this.id = newRoute.query.id;
     this.getNewsContent(newRoute.query.id)
    }
  },
  methods: {
    getNewsContent(id) {
      this.$http
        .post("/v2/SearchNewsById", { id:id})
        .then(res => {
          console.log(res.data, "res");
          this.prevbtn = res.data.newsTop;
          this.nextbtn = res.data.newsNext;
          this.news = res.data.newsContent;
          var end = this.news.jsonContent.length - 1;
          
          this.news.imgPath = JSON.parse(this.news.imgPath);
          this.news.jsonContent = this.news.jsonContent.slice(2, end);
          this.news.jsonContent = this.news.jsonContent.split("}, {"); //内容存为数组

          for (var i = 0; i < this.news.jsonContent.length; i++) {
            var type = this.news.jsonContent[i].slice(1, 4);
            if (type == "img") {
              var imgId = this.news.jsonContent[i].slice(7);
              this.news.jsonContent[i] =
                '"img":"https://hy.imould.com' + this.news.imgPath[imgId] + '"'; //图片编号转图片地址
              this.news.jsonContent[i] = "{" + this.news.jsonContent[i] + ',"str":""}';
              this.news.jsonContent[i] = JSON.parse(this.news.jsonContent[i]);
              
            } else {
               this.news.jsonContent[i] = this.news.jsonContent[i].replace("[\"","\"")
               this.news.jsonContent[i] = this.news.jsonContent[i].replace("\"]}","\"")
               this.news.jsonContent[i] = this.news.jsonContent[i].replace("]}","\"")
               this.news.jsonContent[i] = this.news.jsonContent[i].replace("\"]","\"")
               this.news.jsonContent[i] = this.news.jsonContent[i].replace("[","\"")
               this.news.jsonContent[i] = this.news.jsonContent[i].replace("]","\"")
               this.news.jsonContent[i] = "{" + this.news.jsonContent[i] + "}"
               this.news.jsonContent[i] = this.news.jsonContent[i].replace(/\\r\\n\\t/g," ")
               this.news.jsonContent[i] = JSON.parse(this.news.jsonContent[i])
            }
          }
          this.news.jsonContent = this.news.jsonContent.filter(item => {return item.str.length != 0 || Boolean(item.img)});
        })
        .catch({});
    },
    getHotContent(){
         this.$http.post('/v2/SearchNewsTitle',{formdata:{page:1,limit:10}}).then(res =>{
            this.hotContent = res.data;
          })
    }
  },
  created() {
    this.getHotContent();
    this.id = Number(this.$route.query.id);
    this.formData = Number(this.$route.query.page);
  },
  mounted: function() {
    this.getNewsContent(this.id);
  }
};
</script>

<style scoped>
.NewsContent {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  align-items: flex-start;
}
.NewsContent h3{font-size: 23px;padding-bottom: 15px;text-align: center;}
.NewsContent h5{text-align: center;color: #ccc;font-weight: lighter;font-size: 15px;margin-bottom: 25px;}
.NewsContent p{line-height: 1.7;}
.NewsContent img{margin: 8px 0;}
.NewsContent-l {
  width: 77%;
  padding-right: 25px;
  box-sizing: border-box;
}
.NewsContent-r {
  width: 21%;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
}
.NewsContent-r-title {
  line-height: 30px;
  font-size: 15px;
  padding: 8px 12px;
  color: #0f1720;
  background: #f2f6fa;
  font-weight: 550;
  margin-bottom: 15px;
}
.NewsContent-r-title:before {
  content: " ";
  float: left;
  display: inline;
  width: 4px;
  height: 15px;
  background: #de3d33;
  margin-top: 7px;
  margin-right: 6px;
}
.NewsContent-part{position: relative;margin-bottom: 25px;padding: 0 12px;}
.NewsContent-part p{margin-bottom: 8px;}
.details-title {
  font-size: 13px;
  color: #000000;
  overflow: hidden;
  font-weight: 550;
}
.details {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 12px;
  font-size: 12px;
  color: #8d9096;
  padding-left: 12px;
}
.NewsContent-r a {
  color: #ff0706;
  font-size: 10px;
  
}
.btns {
  position: relative;
  width: 100%;
  height: 30px;
  margin: 10px 0 45px 0;
}
.btns a {
  padding-left: 10px;
}
.btns span {
  width: 70px;
  display: inline-block;
  border: 1px solid #366df0;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  text-align: center;
  line-height: 26px;
  color: #366df0;
}
.prevbtn {
  margin-bottom: 10px;
}
</style>